import React from 'react';

import { Form, Row, Col, Tooltip, Select, Spin, Icon, Table } from 'antd';

import { openNotification } from '../../util/notificaciones';

import PedidosRequest from '../../services/Pedidos';
import PedidosAux from '../../services/PedidosAuxiliares';
// import DetallePedidosAux from './DetallePedidoAux';
import CatalogosRequest from '../../services/Catalogos';
import ResponsiveCard from '../Common/ResponsiveCard';
import BaseComponent from '../Common/BaseComponent';


const { Option } = Select;

class PedidosRealizadosAux extends BaseComponent {
    state = {
        disableComboDrive: false,
        sitioPedidoSelected: undefined,
        sitios: [],
        cargando: false,
        arrPedidosAux: [],
        arrPedidosAuxCopy: [],
        paginacion: {},
        objPedidoSelected: null,
        tipo_modal: "Detalle",
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        filterTextPedidos: "",
        disableDeleteFilters: true,
    }

    /**
     * Comportamiento del componente al recibir nuevos datos
     */
    componentDidMount = () => {
        let state = { ...this.state }
        PedidosRequest.ListarSitiosSupervisor()
            .then( response => {
                state.sitios = response.data.sitio;
                return CatalogosRequest.ListarRegiones();
            })
            .then(response => {
                state.arrRegiones = response.data
                state.cargando = false;
                state.disableComboDrive = localStorage.getItem("role") === 'Administrador' ? true : false
                this.setState(state)
            })
            .catch(err => {
                openNotification("Ocurrió un error al cargar los sitios", "Error", false);
            })
    }

    /**
     * Función para procesar las entradas de texto y eliminar espacios así como
     * caracteres especiales
     * @param: input. entrada de texto al select
     * @param: option. opciones para el filtrado
     * @return: Booleano que indica si la opcion contiene al input
     */
    sanitizerTexto = (input, option) => {
        return option.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
            .toLowerCase().includes(input.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
    }

    /**
     * Se ejecuta cuando se da clic en el combo 
     * para cambiar un sitio
     */
    onChangeSitio = (value) => {
        let state = { ...this.state };
        state.filterTextPedidos = '';
        state.disableDeleteFilters = true;

        if (state.sitioPedidoSelected === undefined) {
            state.arrPedidosAux = []
            state.cargando = false;
            this.setState(state)
        }
        else {
            this.setState({ cargando: true }, () => {
                PedidosAux.CargarPedidosAuxiliares(state.sitioPedidoSelected)
                    .then(response => {
                        state.paginacion = {
                            current: 1,
                            total: response.data.count,
                            onChange: this.handlePaginaChange,
                            pageSize: 10,
                            showTitle: false
                        }

                        state.arrPedidosAux = response.data.results;
                        state.arrPedidosAuxCopy = response.data.results;
                        state.cargando = false;
                        this.setState(state);
                    })
                    .catch(err => {
                        openNotification("Ocurrió un error al cargar los pedidos auxiliares", "Error al cargar pedidos auxiliares", false);
                        this.setState({ cargando: false })
                    });
            });
        }
    }

    /**
     * Función que se cambia la región
     * @param: value. valor del id de la región
     * @return: nada.
     */
    handleChangeRegion = (value) => {
        let state = { ...this.state }
        state.sucursalSelected = null;
        state.plazaSelected = null;
        state.sitioPedidoSelected = null;
        state.arrPedidosAux = [];
        state.arrPedidosAuxCopy = [];

        if (value === undefined) {
            state.regionSelected = null;
        }
        else {
            state.regionSelected = value;
            CatalogosRequest.ListarSucursalesRegion(value).then(response => {
                state.arrSucursales = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las sucursales de la región.",
                    "Error al cargar sucursales",
                    false
                )
            });
        }

        this.setState(state);
    }

    /**
     * Función que se cambia la sucursal
     * @param: value. valor del id de la sucursal
     * @return: nada.
     */
    handleChangeSucursal = (value) => {
        let state = { ...this.state }
        state.plazaSelected = null;
        state.sitioPedidoSelected = null;
        state.arrPedidosAux = [];
        state.arrPedidosAuxCopy = [];

        if (value === undefined) {
            state.sucursalSelected = null;
        } else {
            state.sucursalSelected = value;
            CatalogosRequest.ListarPlazasSucursal(value).then(response => {
                state.arrPlazas = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar las plazas de la sucursal.",
                    "Error al cargar plazas",
                    false
                )
            })
        }

        this.setState(state)
    }

    /**
     * Función que se cambia la plaza
     * @param: value. valor del id de la plaza
     * @return: nada.
    */
    handleChangePlaza = (value) => {
        let state = { ...this.state }
        state.sitioPedidoSelected = null;
        state.arrPedidosAux = [];
        state.arrPedidosAuxCopy = [];

        if (value === undefined) {
            state.plazaSelected = null;
            state.disableComboDrive = true;
        } else {
            state.plazaSelected = value;
            state.disableComboDrive = false;
            CatalogosRequest.ListarSitios(value).then(response => {
                state.sitios = response.data
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al cargar los drives de la plaza.",
                    "Error al cargar drives",
                    false
                )
            })
        }

        this.setState(state);
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handleSearchInput = (value) => {
        let state = { ...this.state };
        let buscar = false;
        if (value.trim() !== state.filterTextPedidos.trim()) buscar = true
        state.filterTextPedidos = value;
        if (value.trim() === "" && !state.fechaPedido.length) {
            state.disableDeleteFilters = true;
        } else {
            state.disableDeleteFilters = false
        }
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.applyFilters();
            }, 1000);
        }
    }


    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        // let state = { ...this.state };
        // let filtros = {};
        // filtros.busqueda = state.filterTextPedidos.trim() !== "" ? state.filterTextPedidos.trim() : undefined
        // filtros.estatus = (state.estatusSelected === undefined || state.estatusSelected === null) ? null : state.estatusSelected
        // filtros.dateInicioPedido = state.datesPedido.length ? state.datesPedido[0] : null
        // filtros.dateFinPedido = state.datesPedido.length ? state.datesPedido[1] : null
        // filtros.dateInicioVencimiento = state.datesVencimiento.length ? state.datesVencimiento[0] : null
        // filtros.dateFinVencimiento = state.datesVencimiento.length ? state.datesVencimiento[1] : null
        // filtros.page = paginaSiguiente
        // state.nextPage = paginaSiguiente;

        // this.setState({ cargando: true }, () => {
        //     Pedidos.CargarPedidosRealizados(state.sitioPedidoSelected, filtros).then(response => {
        //         state.paginacion = {
        //             current: paginaSiguiente
        //         }
        //         response.data.results.forEach(element => {
        //             element.fecha_pedido = moment(element.fecha_pedido).format("DD/MM/YYYY");
        //             element.almacen = (element.almacen === null || element.almacen === undefined) ? 'Almacén General' : element.almacen;
        //             element.fecha_vencimiento = element.fecha_vencimiento === null ? null : moment(element.fecha_vencimiento).utcOffset(0, false).format("DD/MM/YYYY");
        //             element.fecha_entrega = element.fecha_entrega === null ? null : moment(element.fecha_entrega).utcOffset(0, false).format("DD/MM/YYYY");
                    
        //         });
        //         state.arrPedidosRealizadosCopy = response.data.results;
        //         state.arrPedidosRealizadosFiltros = response.data.results;
        //         state.cargando = false;
        //         this.setState(state)
        //     }).catch(err => {
        //         openNotification("Ocurrió un error al realizar los filtrados", "Error al realizar filtros", false);
        //         this.setState({ cargando: false })
        //     })
        // })
    }


    render() {
        const columnasPedidos = [
            ["Asesor", "Barista", "Auditor"].includes(localStorage.getItem("role")) && {
                title: "No. Pedido",
                dataIndex: "pedido_sap",
                key: "pedido_sap",
            },
            {
                title: "Referencia",
                dataIndex: "referencia",
                key: "referencia",
            },
            {
                title: "Fecha de pedido",
                dataIndex: "fecha",
                key: "fecha",
            },
            // {
            //     title: "Acciones",
            //     dataIndex: "Acciones",
            //     key: "Acciones",
            //     render: (value, record) => (
            //         <div>
            //             <div>
            //                 <span style={{ marginRight: 5 }}>
            //                     <Tooltip placement="top" title={"Ver detalle de pedido"}>
            //                         <Button
            //                             icon="eye"
            //                             className="btnVerCrearGuardar"
            //                             onClick={() => {
            //                                 let state = { ...this.state }
            //                                 state.objPedidoSelected = record;
            //                                 state.mostrarModalDetalle = true;
            //                                 this.setState(state)
            //                             }
            //                             }
            //                         >
            //                         </Button>
            //                     </Tooltip>
            //                 </span>
            //             </div>
            //         </div>
            //     )
            // },
        ].filter(Boolean)

        return (
            <ResponsiveCard
                id=""
                title="Módulo de pedidos auxiliares"
            >
                <div className="panel-block">
                    <Row gutter={12}>
                        <Col className={localStorage.getItem("role") === 'Administrador' ? '' : 'display-none'} span={6}>
                            <div className="center">Región:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una región"
                            >
                                <Select
                                    id="select-region-productos-modulo"
                                    showSearch
                                    autoFocus={true}
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    onChange={this.handleChangeRegion}
                                    value={this.state.regionSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrRegiones.length > 0 &&
                                        this.state.arrRegiones.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre_corto}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={localStorage.getItem("role") === 'Administrador' ? '' : 'display-none'} span={6}>
                            <div className="center">Sucursal:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una sucursal">
                                <Select
                                    id="select-sucursal-productos-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.regionSelected === null ? true : false}
                                    onChange={this.handleChangeSucursal}
                                    value={this.state.sucursalSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrSucursales.length > 0 &&
                                        this.state.arrSucursales.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col className={localStorage.getItem("role") === 'Administrador' ? '' : 'display-none'} span={6}>
                            <div className="center">Plaza:</div>
                            <Tooltip
                                placement="top"
                                title="Seleccione una plaza">
                                <Select
                                    id="select-plaza-calendario-modulo"
                                    showSearch
                                    style={{ width: "100%" }}
                                    defaultActiveFirstOption={false}
                                    notFoundContent='No hay opciones'
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.sucursalSelected === null ? true : false}
                                    onChange={this.handleChangePlaza}
                                    value={this.state.plazaSelected}
                                >
                                    <Option value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.arrPlazas.length > 0 &&
                                        this.state.arrPlazas.map(obj => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                        <Col span={this.state.isPos && !this.isAdmin() ? 10 : 6}>
                            <Tooltip placement="top" title="Seleccione un sitio cliente">
                                <div className="center">Seleccione sitio cliente:</div>
                                <Select
                                    defaultActiveFirstOption={false}
                                    allowClear={true}
                                    showSearch
                                    notFoundContent={"No hay opciones"}
                                    style={{ width: "100%" }}
                                    placeholder="Seleccionar..."
                                    optionFilterProp="children"
                                    disabled={this.state.disableComboDrive}
                                    filterOption={(input, option) => this.sanitizerTexto(input, option.props.children)}
                                    value={this.state.sitioPedidoSelected}
                                    onChange={(value) => {
                                        this.setState({ sitioPedidoSelected: value }, this.onChangeSitio)
                                    }}
                                >
                                    <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                    {
                                        this.state.sitios.length > 0 &&
                                        this.state.sitios.map((obj, index) => {
                                            return (
                                                <Option
                                                    key={obj.id}
                                                    value={obj.id}>
                                                    {obj.nombre}
                                                </Option>
                                            )
                                        })
                                    }
                                </Select>
                            </Tooltip>
                        </Col>
                    </Row>
                    {/* <Row gutter={12}>
                        <Col className={!this.state.arrPedidosAux.length ? "display-none" : ""} span={5} >
                            <Tooltip placement="top" title="Buscar pedidos sobre la tabla">
                                <div className="center">Buscar pedidos:</div>
                                <Input
                                    id="userInput"
                                    type="text"
                                    maxLength={100}
                                    value={this.state.filterTextPedidos}
                                    placeholder="Buscar por referencia"
                                    onChange={(e) => this.handleSearchInput(e.currentTarget.value)}
                                />
                            </Tooltip>
                        </Col>
                    </Row> */}
                    <br />
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                    >
                        <Table
                            size="small"
                            pagination={this.state.paginacion}
                            locale={{ emptyText: 'No se han encontrado resultados.' }}
                            rowKey={ pedidos => pedidos.id }
                            columns={ columnasPedidos }
                            dataSource={ this.state.arrPedidosAux }
                            loading={ this.state.loading }
                        />
                    </Spin>
                </div>
                {/* <DetallePedidosAux
                    pedido_selected={this.state.objPedidoSelected}
                    esconderModal={(obj) => {
                        let state = { ...this.state }
                        state.objPedidoSelected = null;
                        state.mostrarModalDetalle = false;
                        this.setState(state)
                    }}
                    visible={this.state.mostrarModalDetalle}
                    tipo_modal={this.state.tipo_modal}
                >

                </DetallePedidosAux> */}
            </ResponsiveCard>
        );
    }

}

export default Form.create()(PedidosRealizadosAux);